export default "__VITE_ASSET__x6YX$438__"